export enum RedemptionOfferingTypeCategoryEnum {
    HealthSavingsAccount = 'HealthSavingsAccount',
    K401 = 'K401',
    Payroll = 'Payroll',
    LifeStyleSpendingAccount = 'Lifestyle Spending Account',
    PremiumCredit = 'Premium Credit'
}
